import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToasterService } from "./toaster.service";

import { Observable, Subject, tap } from "rxjs";
import { JsonResponse } from "@shared/interfaces/JsonResponse.interface";


@Injectable({
    providedIn: 'root'
})
export class LanguagesService {

    public languageChanged$: Subject<string> = new Subject<string>();

    constructor(
        private _http: HttpClient,
        private _toastService: ToasterService
    ) { }

    public getLanguages(isDefault: boolean = true): Observable<JsonResponse<any[]>> {
        return this._http.get<JsonResponse<any[]>>('/languages', { params: { isDefault } }).pipe(
            tap(res => {
                if (!res.success) {
                    this._toastService.error('error', res.message);
                }
            })
        );
    }

}
